'use client'

import { ClientLinkSecondary } from '@fukku/button/ClientLink/Secondary'
import { ButtonSecondary } from '@fukku/button/Secondary'
import { CONTACT_MODAL_ID } from 'help/components/ContactModal/ContactModal'
import { CONTACT_METHODS } from 'help/constants/contactMethods'
import type { ContactMethod } from 'help/services/contactMethods/types'
import { sendOnClickContactLabel } from 'help/utils/analytics/analyticsEvents'
import { ClientLabel } from 'labels/client'
import { useMasterData } from 'master-data/hooks/useMasterData/useMasterData'
import { openChatbot } from 'oldchatbot/utils/openChatbot/openChatbot'
import { cx } from 'utils/cx'

import text from 'fukku/styles/texts.module.scss'
import style from './ContentContactListItem.module.scss'

interface ContentContactListItemProps {
	readonly item: ContactMethod
}

export function ContentContactListItem({ item }: ContentContactListItemProps) {
	const { isApp } = useMasterData()
	const {
		href,
		target = null,
		rel = null,
		buttonText,
		title,
		description,
		type,
		analyticLabel,
	} = item

	const targetProps = isApp
		? {}
		: { ...(target && { target }), ...(rel && { rel }) }

	const closeContactModal = () => {
		const dialog = document.getElementById(CONTACT_MODAL_ID)

		if (dialog) {
			dialog.dispatchEvent(new Event('cancel'))
		}
	}

	const handleOnClick = () => {
		sendOnClickContactLabel({
			label: analyticLabel,
		})
	}

	const handleOnClickChatbot = () => {
		handleOnClick()
		openChatbot()
		closeContactModal()
	}

	return (
		<li
			className={style.item}
			data-testid={`help.contactPage.contactOptions.${type}.item`}
		>
			<div className={style.info}>
				{title && <p className={cx(text.titleXL, style.title)}>{title}</p>}
				{description && (
					<div
						className={cx(style.text, text.bodyM)}
						data-testid={`help.contactPage.contactOptions.${type}.item.text`}
					>
						<ClientLabel>{description}</ClientLabel>
					</div>
				)}
			</div>
			{type === CONTACT_METHODS.CHAT && (
				<ButtonSecondary
					data-testid={'help.contactPage.contactOptions.chat.item.button'}
					className={style.button}
					onClick={handleOnClickChatbot}
				>
					{buttonText}
				</ButtonSecondary>
			)}
			{type !== CONTACT_METHODS.CHAT && href && (
				<ClientLinkSecondary
					data-testid={`help.contactPage.contactOptions.${type}.item.button`}
					className={style.button}
					onClick={handleOnClick}
					href={href}
					linkProps={targetProps}
				>
					{buttonText}
				</ClientLinkSecondary>
			)}
		</li>
	)
}
